<template>
  <div class="not-authorized">
    <h1>You are not authorized to perform this operation.</h1>
    <router-link
      class="button-gemnote button-gemnote--medium"
      to="/report"
      tag="button"
      >Back to home</router-link
    >
  </div>
</template>

<script>
import { layouts } from '../helpers'

export default {
  name: 'UnAuthorized',
  created() {
    this.$store.dispatch('layout/setPageLayout', layouts.DEFAULT_LAYOUT)
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.not-authorized {
  height: 100%;
  width: 100%;
  margin-top: 5rem;

  img {
    width: 10%;
    padding-bottom: 5rem;
  }

  h1 {
    padding-bottom: 2rem;
  }
}
</style>
